<template>
  <v-list-item-group :value="value" active-class="gray--text" @change="select">
    <v-list-item
      v-for="item in list"
      :key="item.value"
      :value="item.value"
      two-line
    >
      <v-list-item-content>
        <v-list-item-title class="font-weight-bold">
          {{ item.name }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ item.description }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list-item-group>
</template>

<script>
export const PERSON = 'person';
export const WAREHOUSE = 'warehouse';
export const types = Object.freeze({
  PERSON,
  WAREHOUSE
});

export default {
  name: 'DeviceTypesList',

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: {
      type: String,
      default: WAREHOUSE,
      validator: prop => Object.values(types).includes(prop)
    }
  },

  computed: {
    list() {
      return [
        {
          name: this.$t('DEVICES.WAREHOUSE_NAME'),
          description: this.$t('DEVICES.WAREHOUSE_DESCRIPTION'),
          value: WAREHOUSE
        },
        {
          name: this.$t('DEVICES.PERSONAL_NAME'),
          description: this.$t('DEVICES.PERSONAL_DESCRIPTION'),
          value: PERSON
        }
      ];
    }
  },

  created() {
    this.select(this.value);
  },

  methods: {
    select(value) {
      this.$emit('change', value);
    }
  }
};
</script>
